import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import switch_locale_path_ssr_5csfIgkrBP from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import route_locale_detect_VrpP1JaYg8 from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/route-locale-detect.js";
import i18n_sq1MuCrqbC from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_UC48QI1yOB from "/app/node_modules/@hypernym/nuxt-anime/dist/runtime/plugin.mjs";
import amplitude_client_a5NDjvTWdZ from "/app/plugins/amplitude.client.ts";
import api_GFfDXud5Cr from "/app/plugins/api.ts";
import auth_vT9JWWT9pN from "/app/plugins/auth.ts";
import axios_QMFgzss1s4 from "/app/plugins/axios.ts";
import clickOutside_client_Zc9fkH3Rh6 from "/app/plugins/clickOutside.client.ts";
import deferred_third_party_client_yUYxp34hLN from "/app/plugins/deferred-third-party.client.ts";
import i18n_VfGcjrvSkj from "/app/plugins/i18n.ts";
import mixpanel_client_JbuVUz27YJ from "/app/plugins/mixpanel.client.ts";
import moment_NWWiRYbNqj from "/app/plugins/moment.ts";
import ssg_detect_3fHkBxLtv0 from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/ssg-detect.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  switch_locale_path_ssr_5csfIgkrBP,
  route_locale_detect_VrpP1JaYg8,
  i18n_sq1MuCrqbC,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_UC48QI1yOB,
  amplitude_client_a5NDjvTWdZ,
  api_GFfDXud5Cr,
  auth_vT9JWWT9pN,
  axios_QMFgzss1s4,
  clickOutside_client_Zc9fkH3Rh6,
  deferred_third_party_client_yUYxp34hLN,
  i18n_VfGcjrvSkj,
  mixpanel_client_JbuVUz27YJ,
  moment_NWWiRYbNqj,
  ssg_detect_3fHkBxLtv0
]